/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AmountFrequency = (typeof AmountFrequency)[keyof typeof AmountFrequency];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AmountFrequency = {
  one_time: "one_time",
  monthly: "monthly",
  quarterly: "quarterly",
  half_yearly: "half_yearly",
  yearly: "yearly",
} as const;
